import React, { useMemo, useState } from "react";
import "../servicesOperation.css";
import InputAutocomplete from "../InputAutocomplete_Form";
import Checkbox from "@mui/material/Checkbox";
import MuiAlert from "@mui/material/Alert";
import Grid from "@mui/material/Unstable_Grid2";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import {
  options_origen_devolucion,
  options_deposito_destino,
  options_condicion,
  options_sintoma,
  options_aceptamos_devolucion_safe,
  data_aceptamos_devolucion,
} from "../Helper/data_Admin";
import { TextField, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { enviarDatosAlServidor } from "../Helper/Post_Json";
import useAuth from "hooks/useAuth";
import SuccessModal from "views/Components/SuccessModal";
import ErrorModal from "views/Components/ErrorModal";
import { useParams, useNavigate } from "react-router-dom";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

// Definimos el componente Admin
const Taller_Form_Body = ({
  formData,
  setFormData,
  isLoading,
  isSubmitting,
  datataller_componente,
  datataller_deposito_destino,
  setDataTaller_deposito_destino,
  datataller_descripcion,
  datataller_estado_sku,
  datataller_estetica_packaging,
  datataller_estetica_producto,
  datataller_falla,
  datataller_lote,
  datataller_motivo_del_scrap,
  datataller_reparacion,
  datataller_responsable,
}) => {
  //Estado para capturar el valor del checkbox

  //Estados para validación de cada input
  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [open, setOpen] = React.useState(false);
  const { accessToken } = useAuth();
  const [successOpen, setSuccessOpen] = useState(false);
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const navigate = useNavigate(); // Obtiene la función de navegación

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccessClose = () => {
    setSuccessOpen(false);
    navigate("/service-operation/services_operation");
  };
  const handleErrorClose = () => {
    setErrorOpen(false);
  };

  const handleFree = async () => {
    const payload = {
      id: formData["id"],
      nombre_usuario: "",
    };
    setOpen(false);
    const resultado = await enviarDatosAlServidor(
      payload,
      "ServiceOperation/UpdateTecnicoTaller",
      accessToken,
    );

    if (resultado.success) {
      setSuccessOpen(true);
      return;
    }

    setErrorOpen(true);
    setErrorMessage("Error al liberar un ticket");
  };

  // Función para marcar un campo como tocado
  const handleBlur = (id) => {
    setTouched((prevState) => ({
      ...prevState,
      [id]: true,
    }));
    validateField(id, formData[id]);
  };

  const validateField = (id, value) => {
    // Si el valor es nulo o el string vacío, establecer el error
    if (!value) {
      setErrors((prevState) => ({
        ...prevState,
        [id]: "Este campo es obligatorio",
      }));
    } else {
      // Eliminar el error si el campo es válido
      setErrors((prevState) => {
        const newState = { ...prevState };
        delete newState[id];
        return newState;
      });
    }
  };

  //Captura Inputs Autocomplete
  const handleChangeAutoComplete = (id, newInputValue) => {
    // console.log(id);
    // console.log("Nuevo valor seleccionado:", newInputValue);

    setFormData((prevState) => ({
      ...prevState,
      [id]: newInputValue ? newInputValue.id : 0,
    }));

    if (
      id === "numero_serie" ||
      id === "codigo_barra" ||
      id === "comentarios"
    ) {
      setFormData((prevState) => ({
        ...prevState,
        [id]: newInputValue ? newInputValue : null,
      }));
    }
    //setTouched({ ...touched, [id]: true }); // Marca el campo como tocado
    setTouched((prevState) => ({ ...prevState, [id]: true }));
    // Validar después de actualizar
    validateField(id, newInputValue);
  };

  const descripcion_Seleccionado = datataller_descripcion.find(
    (option) => option.id === formData["id_descripcion"],
  );

  // console.log(datataller_descripcion);
  // console.log(formData['id_descripcion']);
  // console.log(descripcion_Seleccionado);

  const lote_Seleccionado = datataller_lote.find(
    (option) => option.id === formData["id_lote"],
  );
  const falla_Seleccionado = datataller_falla.find(
    (option) => option.id === formData["id_falla"],
  );
  const componente_Seleccionado = datataller_componente.find(
    (option) => option.id === formData["id_componente"],
  );
  const estetica_packaging_Seleccionado = datataller_estetica_packaging.find(
    (option) => option.id === formData["id_estetica_packaging"],
  );
  const estetica_producto_Seleccionado = datataller_estetica_producto.find(
    (option) => option.id === formData["id_estetica_producto"],
  );

  const numero_serie_Seleccionado = formData["numero_serie"];

  //IMPLEMENTAMOS FILTRO DE "DEPÓSITO DESTINO" antes de mostrar las opciones

  let filtroDeposito_Destino;

  if (formData["deposito_destino_name"]) {
    const campo = formData["deposito_destino_name"];
    const initials = campo ? campo.split("(")[1].slice(0, 2) : null;
    filtroDeposito_Destino = datataller_deposito_destino.filter((option) =>
      option.name.includes(`(${initials})`),
    );
  } else {
    filtroDeposito_Destino = datataller_deposito_destino;
  }

  const deposito_destino_Seleccionado = filtroDeposito_Destino.find(
    //(option) => option.id === formData['id_deposito_destino']
    (option) => option.id === formData["id_deposito_destino"],
  );
  console.log(formData);
  // console.log(formData["id"]);

  const reparacion_Seleccionado = datataller_reparacion.find(
    (option) => option.id === formData["id_reparacion"],
  );
  const motivo_del_scrap_Seleccionado = datataller_motivo_del_scrap.find(
    (option) => option.id === formData["id_motivo_scrap"],
  );

  //console.log(formData['id_motivo_scrap']);
  //console.log(motivo_del_scrap_Seleccionado);

  const codigo_barra_Seleccionado = formData["codigo_barra"];

  const estado_sku_Seleccionado = datataller_estado_sku.find(
    (option) => option.id === formData["id_estado_sku"],
  );
  const responsable_Seleccionado = datataller_responsable.find(
    (option) => option.id === formData["id_responsable"],
  );

  const comentarios_Seleccionado = formData["comentarios"];

  //Función para habilitar o bloquear botón de Enviar una vez que haya datos en cada Input
  const isFormValid = useMemo(() => {
    const requiredFields = [
      "id_descripcion",
      //   "id_lote",
      "id_falla",
      "id_componente",
      //   "id_estetica_packaging",
      //   "id_estetica_producto",
      "id_deposito_destino",
      "id_reparacion",
      "id_estado_sku",
      "id_responsable",
    ];

    if (
      deposito_destino_Seleccionado &&
      deposito_destino_Seleccionado.name.includes("Reacondicionado")
    ) {
      requiredFields.push("numero_serie");
    }

    if (
      deposito_destino_Seleccionado &&
      deposito_destino_Seleccionado.name.includes("Perdida")
    ) {
      requiredFields.push("id_motivo_scrap");
      requiredFields.push("comentarios");
    }

    if (motivo_del_scrap_Seleccionado) {
      requiredFields.push("comentarios");
    }

    // Verifica si alguno de los campos requeridos está vacío
    return requiredFields.every((field) => {
      const value = formData[field];
      // console.log(field);
      // console.log(value);
      if (typeof value === "string") {
        return value.trim() !== "";
      } else {
        return value !== null && value !== undefined && value !== 0; //&& value !== 1; // Para los números y booleanos, solo verificar si no son nulos o indefinidos
        //Los 0 son las opciones vacías, y los 1 son los que tienen valor SYSTEM, osea, null o vacío
      }
    });
  }, [formData, deposito_destino_Seleccionado, motivo_del_scrap_Seleccionado]);

  //Lógica para liberar ticket si se presiona el botón de "Liberar"
  //Esto debe estar dentro de la función cuando se ejecuta el ticket.
  //Sumado también el que notifique al usuario del cambio
  /* const fetchFormDataFree = async () => {
		const obj_user_update = {
			id: parsedId,
			nombre_usuario: userNickname,
		};
		const resultado = await enviarDatosAlServidor(
			obj_user_update,
			'UpdateTecnicoTaller',
			accessToken
		);

	} */
  const cleanForm = () => {
    setFormData({
      ...formData,
      id_descripcion: null,
      id_falla: null,
      id_componente: null,
      numero_serie: "",
      id_deposito_destino: null,
      id_reparacion: null,
      id_motivo_scrap: null,
      id_estado_sku: null,
      id_responsable: null,
      comentarios: "",
    });
    setTouched({});
    setErrors({});
  };

  const isDisabled = () => !isFormValid || isLoading || isSubmitting;

  return (
    <>
      {isLoading ? (
        <></>
      ) : (
        <>
          <Box
            sx={{
              flexGrow: 1,
              gap: "16px",
              flexDirection: "column",
              display: "flex",
              marginTop: "16px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "24px",
                letterSpacing: "0.15px",
                color: "#00000061",
              }}
            >
              Gestión SOR
            </Typography>
            <Grid
              container
              spacing={{ xs: 2, md: 3 }}
              columns={{ xs: 4, sm: 8, md: 12 }}
            >
              <Grid item xs={12} sm={4} md={4} key="1">
                <InputAutocomplete
                  id="id_descripcion"
                  value={descripcion_Seleccionado || null}
                  label="Descripción"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_descripcion", newValue)
                  }
                  error={
                    touched["id_descripcion"] &&
                    Boolean(errors["id_descripcion"])
                  }
                  onBlur={() => handleBlur("id_descripcion")}
                  required={true}
                  helperText={
                    touched["id_descripcion"] ? errors["id_descripcion"] : ""
                  }
                  options={
                    datataller_descripcion
                      ? datataller_descripcion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_condicion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="2">
                <InputAutocomplete
                  id="id_lote"
                  value={lote_Seleccionado || null}
                  label="Lote"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_lote", newValue)
                  }
                  error={touched["id_lote"] && Boolean(errors["id_lote"])}
                  onBlur={() => handleBlur("id_lote")}
                  required={true}
                  helperText={touched["id_lote"] ? errors["id_lote"] : ""}
                  options={
                    datataller_lote
                      ? datataller_lote.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="3">
                <InputAutocomplete
                  id="id_falla"
                  value={falla_Seleccionado || null}
                  label="Falla"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_falla", newValue)
                  }
                  error={touched["id_falla"] && Boolean(errors["id_falla"])}
                  onBlur={() => handleBlur("id_falla")}
                  required={true}
                  helperText={touched["id_falla"] ? errors["id_falla"] : ""}
                  options={
                    datataller_falla
                      ? datataller_falla.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="4">
                <InputAutocomplete
                  id="id_componente"
                  value={componente_Seleccionado || null}
                  label="Componente"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_componente", newValue)
                  }
                  error={Boolean(
                    touched?.["id_componente"] && errors?.["id_componente"],
                  )}
                  onBlur={() => handleBlur("id_componente")}
                  required={true}
                  helperText={
                    touched["id_componente"] && errors["id_componente"]
                  }
                  options={
                    datataller_componente
                      ? datataller_componente.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_origen_devolucion
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="5">
                <InputAutocomplete
                  id="id_estetica_packaging"
                  value={estetica_packaging_Seleccionado || null}
                  label="Estetica Packaging"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estetica_packaging", newValue)
                  }
                  error={
                    touched["id_estetica_packaging"] &&
                    Boolean(errors["id_estetica_packaging"])
                  }
                  onBlur={() => handleBlur("id_estetica_packaging")}
                  required={true}
                  helperText={
                    touched["id_estetica_packaging"]
                      ? errors["id_estetica_packaging"]
                      : ""
                  }
                  options={
                    datataller_estetica_packaging
                      ? datataller_estetica_packaging.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              {/* <Grid item xs={12} sm={4} md={4} key="6">
                <InputAutocomplete
                  id="id_estetica_producto"
                  value={estetica_producto_Seleccionado || null}
                  label="Estetica Producto"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estetica_producto", newValue)
                  }
                  error={
                    touched["id_estetica_producto"] &&
                    Boolean(errors["id_estetica_producto"])
                  }
                  onBlur={() => handleBlur("id_estetica_producto")}
                  required={true}
                  helperText={
                    touched["id_estetica_producto"]
                      ? errors["id_estetica_producto"]
                      : ""
                  }
                  options={
                    datataller_estetica_producto
                      ? datataller_estetica_producto.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid> */}
              <Grid item xs={12} sm={4} md={4} key="7">
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      backgroundColor: "#fff !important",
                      borderRadius: "8px",
                      WebkitBoxShadow: "0 0 0 1000px white inset",
                    },
                  }}
                  id="numero_serie"
                  label="Número de Serie"
                  value={numero_serie_Seleccionado}
                  required={
                    deposito_destino_Seleccionado &&
                    deposito_destino_Seleccionado.name.includes(
                      "Reacondicionado",
                    )
                  }
                  onChange={(event) =>
                    handleChangeAutoComplete("numero_serie", event.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="8">
                <InputAutocomplete
                  id="id_deposito_destino"
                  value={deposito_destino_Seleccionado || null}
                  label="Depósito destino"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_deposito_destino", newValue)
                  }
                  error={
                    touched["id_deposito_destino"] &&
                    Boolean(errors["id_deposito_destino"])
                  }
                  onBlur={() => handleBlur("id_deposito_destino")}
                  required={true}
                  helperText={
                    touched["id_deposito_destino"]
                      ? errors["id_deposito_destino"]
                      : ""
                  }
                  options={
                    filtroDeposito_Destino
                      ? filtroDeposito_Destino.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_deposito_destino
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} sm={4} md={4} key="9">
                <InputAutocomplete
                  id="id_reparacion"
                  value={reparacion_Seleccionado || null}
                  label="Reparación"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_reparacion", newValue)
                  }
                  error={
                    touched["id_reparacion"] && Boolean(errors["id_reparacion"])
                  }
                  onBlur={() => handleBlur("id_reparacion")}
                  required={true}
                  helperText={
                    touched["id_reparacion"] ? errors["id_reparacion"] : ""
                  }
                  options={
                    datataller_reparacion
                      ? datataller_reparacion.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>

              <Grid item xs={12} sm={4} md={4} key="10">
                <InputAutocomplete
                  id="id_motivo_scrap"
                  value={motivo_del_scrap_Seleccionado || null}
                  label="Motivo del Scrap"
                  required={
                    deposito_destino_Seleccionado &&
                    deposito_destino_Seleccionado.name.includes("Perdida")
                  }
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_motivo_scrap", newValue)
                  }
                  options={
                    datataller_motivo_del_scrap
                      ? datataller_motivo_del_scrap.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              {/* <Grid item xs={12} sm={4} md={4} key="11">
                <TextField
                  sx={{ width: "100%" }}
                  id="codigo_barra"
                  label="Codigo de Barra"
                  required={
                    deposito_destino_Seleccionado &&
                    deposito_destino_Seleccionado.name.includes(
                      "Reacondicionado",
                    )
                  }
                  value={codigo_barra_Seleccionado}
                  onChange={(event) =>
                    handleChangeAutoComplete("codigo_barra", event.target.value)
                  }
                />
              </Grid> */}

              <Grid item xs={12} sm={4} md={4} key="12">
                <InputAutocomplete
                  id="id_estado_sku"
                  value={estado_sku_Seleccionado || null}
                  label="Estado del SKU"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_estado_sku", newValue)
                  }
                  error={
                    touched["id_estado_sku"] && Boolean(errors["id_estado_sku"])
                  }
                  onBlur={() => handleBlur("id_estado_sku")}
                  required={true}
                  helperText={
                    touched["id_estado_sku"] ? errors["id_estado_sku"] : ""
                  }
                  options={
                    datataller_estado_sku
                      ? datataller_estado_sku.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_sintoma
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>

              <Grid item xs={12} sm={4} md={4} key="13">
                <InputAutocomplete
                  id="id_responsable"
                  value={responsable_Seleccionado || null}
                  label="Responsable"
                  onChange={(event, newValue) =>
                    handleChangeAutoComplete("id_responsable", newValue)
                  }
                  error={
                    touched["id_responsable"] &&
                    Boolean(errors["id_responsable"])
                  }
                  onBlur={() => handleBlur("id_responsable")}
                  required={true}
                  helperText={
                    touched["id_responsable"] ? errors["id_responsable"] : ""
                  }
                  options={
                    datataller_responsable
                      ? datataller_responsable.map((condicion) => ({
                          name: condicion.name,
                          id: condicion.id,
                        }))
                      : options_aceptamos_devolucion_safe
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                />
              </Grid>
              <Grid item xs={12} key="14">
                <TextField
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                    },
                    "& .MuiOutlinedInput-input": {
                      backgroundColor: "#fff !important",
                      borderRadius: "8px",
                      WebkitBoxShadow: "0 0 0 1000px white inset",
                    },
                  }}
                  id="comentarios"
                  label="Comentarios"
                  value={comentarios_Seleccionado || null}
                  required={
                    motivo_del_scrap_Seleccionado ||
                    (deposito_destino_Seleccionado &&
                      deposito_destino_Seleccionado.name.includes("Perdida"))
                  }
                  onChange={(event) =>
                    handleChangeAutoComplete("comentarios", event.target.value)
                  }
                />
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 2,
              gap: 2,
            }}
          >
            <Button
              type="button"
              variant="outlined"
              onClick={cleanForm}
              style={{
                color: "#002878",
                fontWeight: 500,
                borderColor: "#002878",
                width: "120px",
                textTransform: "uppercase",
              }}
            >
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="contained"
              style={{
                color: isDisabled() ? "rgba(0, 0, 0, 0.26)" : "white",
                backgroundColor: isDisabled() ? "#0000001F" : "#002878",
                width: "120px",
                textTransform: "uppercase",
              }}
              color="primary"
              disabled={isDisabled()}
            >
              GUARDAR
            </Button>
          </Box>
          <React.Fragment>
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"¿Estás seguro de liberar este ticket?"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Si liberas este ticket, otras personas podrán tomarlo y no
                  podrás editar ni trabajar sobre este ticket. Deseas liberar
                  este ticket?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button onClick={handleFree} autoFocus>
                  Aceptar
                </Button>
              </DialogActions>
            </Dialog>
          </React.Fragment>

          <SuccessModal
            handleClose={handleSuccessClose}
            open={successOpen}
            message="La operación fue un éxito!"
            message2={`Se liberó correctamente el Ticket N° ${formData["id"]}`}
          />
          <ErrorModal
            handleClose={handleErrorClose}
            open={errorOpen}
            message="Error"
            message2={errorMessage}
          />
        </>
      )}
    </>
  );
};

export default Taller_Form_Body;
